<template>
    <Transition
        name="expand"
        v-on:after-enter="onAfterEnter"
        v-on:enter="onEnter"
        v-on:leave="onLeave"
    >
        <slot />
    </Transition>
</template>

<script lang="ts" setup>
    function onAfterEnter(element: Element) {
        (element as HTMLElement).style.height = 'auto';
    }

    function onEnter(element: Element) {
        const el = element as HTMLElement;
        const { width } = getComputedStyle(el);
        el.style.width = width;
        el.style.position = 'absolute';
        el.style.visibility = 'hidden';
        el.style.height = 'auto';
        const { height } = getComputedStyle(el);
        el.style.width = '';
        el.style.position = '';
        el.style.visibility = '';
        el.style.height = '0';
        (() => el.offsetHeight)();
        requestAnimationFrame(() => {
            el.style.height = height;
        });
    }

    function onLeave(element: Element) {
        const el = element as HTMLElement;
        const { height } = getComputedStyle(el);
        el.style.height = height;
        (() => el.offsetHeight)();
        requestAnimationFrame(() => {
            el.style.height = '0';
        });
    }
</script>

<style scoped>
.expand-enter-active,
.expand-leave-active {
    overflow: hidden;
    transition: height 0.3s ease-in-out;
}

.expand-enter,
.expand-leave-to {
    height: 0;
}

* {
    backface-visibility: hidden;
    perspective: 1000px;
    transform: translateZ(0);
    will-change: height;
}
</style>
